export const REPORTS_LOADED = 'reportsLoaded';
export const REMOVE_REPORT = 'removeReport';
export const REPORT_CHANGED = 'reportChanged';
